import { useQuery } from "@tanstack/react-query";
import { api, client } from "../lib/api";

export function useMe() {
  return useQuery({ queryKey: ["me"], queryFn: () => api.me(client), staleTime: 60_000 });
}
